import DynamicButton from "../../core/components/button/dynamicButton";
import {Localizer} from "../../infrastructure/localization/localizer";
import React from "react";
import {ReactTooltip} from "../../core/components/tooltips/ReactTooltip";
import {CheckboxSwitch} from "../../core/components/checkbox/checkboxSwitch";
import {ReactComponent as GearIcon} from "../../content/icons/gear-solid.svg";
import {DashboardCardSettingsOption} from "./models/DashboardCardSettingsOption";

type DashboardCardSettingsProps = {
    id: string;
    options: DashboardCardSettingsOption[];
}
const DashboardCardSettings = ({id, options}: DashboardCardSettingsProps) => {
    return <>
        <DynamicButton id={id} additionalClasses={"align-items-center"} rounded>
            <GearIcon/>
        </DynamicButton>
        <ReactTooltip selectId={id} delay={100}>
            <div className="flex-container-column ">
                <h4 className={"margin-bottom-s flex-start"}>{Localizer.forloebOverviewPage_forloebOverviewSettings()}</h4>
                {options.map((option, index) => (
                    <div className={"margin-bottom-s"}>
                        <CheckboxSwitch key={index}
                                        id={`showLabelValues-${index}`}
                                        label={option.label}
                                        value={option.checkedValue}
                                        reverseTextAndSwitch
                                        onChange={(value) => option.setCheckedValue(value.target.checked)}
                        />
                    </div>
                ))}
            </div>
        </ReactTooltip>
    </>
}
export default DashboardCardSettings
